import { Model } from "backbone";
/* eslint-disable
    consistent-return,
    constructor-super,
    default-case,
    no-constant-condition,
    no-eval,
    no-multi-assign,
    no-return-assign,
    no-shadow,
    no-this-before-super,
    no-underscore-dangle,
    no-unused-expressions,
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS001: Remove Babel/TypeScript constructor workaround
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
let ContentSubscription;
export default ContentSubscription = class ContentSubscription extends Model {
  constructor(...args) {
    super(...args);
    this.toggle = this.toggle.bind(this);
    this.softSubscribe = this.softSubscribe.bind(this);
    this.subscribe = this.subscribe.bind(this);
    this.suppress = this.suppress.bind(this);
    this.isSubscribed = this.isSubscribed.bind(this);
    this._handleError = this._handleError.bind(this);
  }

  url() { return `/content/${this.content_id}/content_subscription`; }

  initialize(options) {
    return this.content_id = options.content_id;
  }

  toggle() {
    switch (this.get("subscription_type")) {
      case "subscribed":
        return this.suppress();
      case "suppressed":
        return this.subscribe();
      case "undetermined":
        return this.subscribe();
    }
  }

  softSubscribe() {
    if (this.get("subscription_type") === "undetermined") {
      return this.subscribe();
    }
  }

  subscribe() {
    return this.save({ subscription_type: "subscribed" }, { type: "PUT", error: this._handleError });
  }

  suppress() {
    return this.save({ subscription_type: "suppressed" }, { type: "PUT", error: this._handleError });
  }

  isSubscribed() {
    return this.get("subscription_type") === "subscribed";
  }

  _handleError() {
    return this.set("subscription_type", this.previous("subscription_type"));
  }
};
